import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { fetchDistinctAttributesForLens } from "../../../data/queries/artifacts";
import { MS_PER_SECOND, SECONDS_PER_MINUTE } from "../../../utils/date";
import { useAuth } from "../../auth/AuthContext";

const STALE_TIME_MINUTES = 5;
const STALE_TIME_MS = STALE_TIME_MINUTES * SECONDS_PER_MINUTE * MS_PER_SECOND;

interface UseLensAttributesParams {
  lensName: string | null;
}

export const useLensAttributes = ({ lensName }: UseLensAttributesParams): UseQueryResult<string[]> => {
  const { tenantId } = useAuth();

  return useQuery<string[]>({
    enabled: !!lensName && !!tenantId,
    queryKey: ["lensAttributes", tenantId, lensName],
    queryFn: async () => {
      const result = await fetchDistinctAttributesForLens(lensName!);
      if (result.error) {
        throw result.error;
      }
      return result.data;
    },
    staleTime: STALE_TIME_MS
  });
};
